import { ForgetPasswordConfirmationPage } from "@/pages/forget/password/confirmation";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/forget/password/confirmation/")({
	component: RouteComponent,
});

function RouteComponent() {
	return <ForgetPasswordConfirmationPage />;
}
